export default __webpack_public_path__ + "static/media/fitness.5b469c44.svg";